import React from 'react';
import { GenreNameToKey } from '@soundxyz/utils/const';
import { ParamsStore } from '@context/params';
import { scrollToTop } from '@utils/helpers';
import { EXPLORE_TYPES } from '../schema';
import { setDefaultSort, setExploreType } from '../useSearchPageStore';
import { GenreCard } from './GenreCard';
import { GENRE_DATA } from './data';

export const SoundsByGenres = () => {
  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex justify-between">
        <h3 className="font-title text-title-m font-medium md:text-title-l">Sounds by Genre</h3>
      </div>
      <div className="grid grid-cols-2 gap-2 md:grid-cols-4 md:gap-4 lg:grid-cols-5 xl:grid-cols-6">
        {GENRE_DATA.map((data, index) => {
          const IS_PRIORITY_IMAGE = index < 6 ? true : false;

          return (
            <GenreCard
              key={index}
              label={data.label}
              backgroundColor={data.backgroundColor}
              imgUrl={data.imgUrl}
              isPriorityImage={IS_PRIORITY_IMAGE}
              onClick={() => {
                scrollToTop();
                setExploreType({ type: EXPLORE_TYPES.SOUNDS });
                setDefaultSort({ type: EXPLORE_TYPES.SOUNDS });
                ParamsStore.genre = GenreNameToKey[data.key];
              }}
            />
          );
        })}
      </div>
    </div>
  );
};
